import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { ProductPrices } from "../state/types"

export const useProductPricesActions = () => {
    const saveActions = useSaveActions()

    const saveProductPrices = (productPrices: ProductPrices) => {
        const { save } = saveActions()
        return save(TableName.PRODUCT_PRICES, productPrices) as Promise<ProductPrices>
    }

    const saveProductPricesList = (productPricesList: ProductPrices[]) => {
        const { saveMultiple } = saveActions()
        return saveMultiple(TableName.PRODUCT_PRICES, productPricesList) as Promise<ProductPrices[]>
    }

    const removeProductPrices = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.PRODUCT_PRICES, id)
    }

    return {
        saveProductPrices,
        saveProductPricesList,
        removeProductPrices
    }
}
